import ReactDOM from 'react-dom';
import EntryPoint from './components/entry-point';

ReactDOM.render(<EntryPoint />, document.getElementById('app'));
